<h2 mat-dialog-title>Categoría de {{ data.participant_name }}</h2>

<mat-dialog-content [formGroup]="form">
  <p class="hint">Elige cómo este usuario registrará el tiempo de este evento.</p>

  <mat-label>Categoría</mat-label>
  <mat-form-field appearance="outline" class="full">
    <mat-select formControlName="working_time_category_level_0" (selectionChange)="onCategoryChange($event.value, 0)">
      @for (wtc of data.working_time_categories; track wtc.id) {
        <mat-option [value]="wtc.id">{{ wtc.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (is_company_product_category) {
    <mat-label>Producto</mat-label>
    <mat-form-field appearance="outline" class="full">
      <input
        type="text"
        matInput
        [formControl]="company_product_control"
        [matAutocomplete]="productAuto"
        placeholder="Buscar productos..."
      />
      <mat-autocomplete
        #productAuto="matAutocomplete"
        (optionSelected)="selectCompanyProduct($event.option.value)"
        [displayWith]="displayFnCompanyProduct"
      >
        @for (company_product of filtered_company_products(); track company_product.id) {
          <mat-option [value]="company_product">{{ company_product.title }}</mat-option>
        }
      </mat-autocomplete>
      @if (form.controls['company_product_id'].value) {
        <button matSuffix mat-icon-button type="button" aria-label="Clear" (click)="resetCompanyProduct()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  }

  @for (children of available_children_by_level(); track $index; let level = $index) {
    @if (children.length > 0 && selected_working_time_categories()[level]) {
      <mat-label>Sub. de {{ selected_working_time_categories()[level].name }}</mat-label>
      <mat-form-field appearance="outline" class="full">
        <mat-select
          [formControlName]="'working_time_category_level_' + (level + 1)"
          (selectionChange)="onCategoryChange($event.value, level + 1)"
        >
          @for (category of children; track category.id) {
            <mat-option [value]="category.id">{{ category.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  }

  @if (is_company_product_phase_category) {
    <mat-label>Fase</mat-label>
    <mat-form-field appearance="outline" class="full">
      <input
        type="text"
        matInput
        [formControl]="company_product_phase_control"
        [matAutocomplete]="phaseAuto"
        placeholder="Buscar fases..."
      />
      <mat-autocomplete
        #phaseAuto="matAutocomplete"
        (optionSelected)="selectCompanyProductPhase($event.option.value)"
        [displayWith]="displayFnCompanyProductPhase"
      >
        @for (phase of filtered_company_product_phases(); track phase.id) {
          <mat-option [value]="phase">{{ phase.company_product_phase_type.name }}</mat-option>
        }
      </mat-autocomplete>
      @if (form.controls['company_product_phase_id'].value) {
        <button matSuffix mat-icon-button type="button" aria-label="Clear" (click)="resetCompanyProductPhase()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Cancelar</button>
  <button mat-flat-button color="accent" type="button" (click)="save()">Guardar</button>
</mat-dialog-actions>
